export default __webpack_public_path__ + "static/media/06.78dc6653.png";